import React, { Component } from 'react'
import SRCards from '../../components/SRCards'
import history from '../../services/history.service'
import update from 'immutability-helper';
import CustomerApi from '../../services/customer.service'
import {
    Button, Container, Checkbox, Paper, TableContainer, TextField, Table,
    TableHead, TableRow, TableCell, TableBody, Typography, TableFooter, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions
} from '@material-ui/core'

type IProps = {
    location: any
}
type IState = {
    id: any;
    customers: any,
    selections: any;
    dialog:any,
    msg:any,
}
const apiservices = new CustomerApi();

class CustomerList extends Component<IProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            id: [],
            customers: [],
            selections: {},
            dialog:false,
            msg:''
        };
    }

    handleSelect = (id: any) => {
        this.setState((prevState) => {
            if (prevState.selections[id]) {
                return update(prevState, {
                    selections: { $unset: [id] },
                });
            }
            return update(prevState, {
                selections: { [id]: { $set: true } },
            });
        });
    }
    isItemSelected = (id: string | number) => this.state.selections[id];

    async onSearch(e: any) {
        const response = await apiservices.getCustomers(
            e.target.value
        );
        this.setState({
            customers: response
        })
    }

    async getData() {
        let customerType = this.state.id[0] && this.state.id[0].serviceAddresses ? 0 : 1
        var response, customerDetails, res;
        if(this.state.id.length > 1) {
            this.setState({
                dialog:true,
                msg:'You can select only 1 customer to edit.'
            })
        } else {
            if (customerType === 0) {
                response = await apiservices.getCustomerDetails(
                    this.state.id, customerType
                );
                res = {
                    'response': response,
                    'customerType': customerType
                }
            }
            else {
                customerDetails = await apiservices.getCustomerDetails(
                    this.state.id, customerType
                );
                response = await apiservices.getAddressDetails(
                    this.state.id
                );
                res = {
                    'response': response,
                    'customerDetails': customerDetails,
                    'customerType': customerType
                }
            }
            history.push(`/customers/edit/${this.state.id[0].id}`, res)
        }
    }

    render() {
        return (
            <div>
                <SRCards />
                <Container>
                    <Typography
                        style={{ padding: 16 }}
                    >
                        {localStorage.getItem('selectedCompanyDisplay')}
                    </Typography>
                    <TextField
                        style={{ padding: 16 }}
                        variant="outlined"
                        onChange={(e) => this.onSearch(e)}
                        placeholder='Search Customer..' />
                    <TableContainer
                        component={Paper}
                        style={{
                            padding: 10, margin: 16
                        }}
                    >
                        <Button
                            style={{ margin: 10 }}
                            disabled={this.state.id.length > 0 ? false : true}
                            size='large'
                            variant='outlined'
                            onClick={this.getData.bind(this)}>
                            Edit
                                </Button>
                        <Table
                            style={{
                                minWidth: 700
                            }}
                            aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Select</TableCell>
                                    <TableCell>Customer Name</TableCell>
                                    <TableCell>Customer ID</TableCell>
                                    <TableCell>Customer Type</TableCell>
                                    <TableCell>Primary/Secondary</TableCell>
                                </TableRow>
                            </TableHead>
                            {this.state.customers.length > 0?
                                this.state.customers.map((set: any) => {
                                return (
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>
                                                <Checkbox
                                                    key={set.id}
                                                    defaultChecked={false}
                                                    checked={
                                                        this.isItemSelected(set.id)
                                                    }
                                                    onChange={() => {
                                                        this.handleSelect(set.id)
                                                        if (!this.state.id.includes(set)) {
                                                            this.state.id.push(set)
                                                        }
                                                        else {
                                                            const i = this.state.id.indexOf(set);
                                                            this.state.id.splice(i, 1)
                                                        }
                                                        this.setState({
                                                            id: this.state.id
                                                        })
                                                    }
                                                    } />
                                            </TableCell>
                                            <TableCell>
                                                {set.displayName}
                                            </TableCell>
                                            <TableCell>
                                                {set.customerIdentifier}
                                            </TableCell>
                                            <TableCell>
                                                Root Customer
                                            </TableCell>
                                            <TableCell>
                                                Primary
                                            </TableCell>
                                        </TableRow>
                                        {set.serviceAddresses.length > 1 ?
                                            set.serviceAddresses
                                                .filter((temp: any) =>
                                                    (!temp.isParent)
                                                )
                                                .map((temp: any) => {
                                                    return (
                                                        <TableRow>
                                                            <TableCell>
                                                                <Checkbox
                                                                    key={temp.id}
                                                                    defaultChecked={false}
                                                                    checked={
                                                                        this.isItemSelected(temp.id)
                                                                    }
                                                                    onChange={() => {
                                                                        this.handleSelect(temp.id)
                                                                        if (!this.state.id.includes(temp)) {
                                                                            this.state.id.push(temp)
                                                                        }
                                                                        else {
                                                                            const i = this.state.id.indexOf(temp);
                                                                            this.state.id.splice(i, 1)
                                                                        }
                                                                        this.setState({
                                                                            id: this.state.id
                                                                        })
                                                                    }
                                                                    } />
                                                            </TableCell>
                                                            <TableCell>
                                                                {temp.displayName}
                                                            </TableCell>
                                                            <TableCell>
                                                                {temp.customerIdentifier}
                                                            </TableCell>
                                                            <TableCell>
                                                                Service
                                                            </TableCell>
                                                            <TableCell>
                                                                Secondary
                                                            </TableCell>
                                                        </TableRow>)
                                                }) : null}
                                    </TableBody>
                                )
                            }):null}
                            <TableFooter>
                                <TableRow>

                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>
                    <Dialog
                        open={this.state.dialog}
                        onClose={() => {
                            this.setState({
                                dialog: false
                            })
                        }}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <DialogTitle id="alert-dialog-title">
                            Note
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText
                                id="alert-dialog-description"
                            >
                                {this.state.msg}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                        <Button
                            onClick={
                                () => {
                                    this.setState({
                                        dialog:false
                                    })
                                }
                            }
                        >
                            Close
                        </Button>
                    </DialogActions> 
                    </Dialog>
                </Container>
            </div>
        )
    }
}

export default CustomerList;